import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showDrawer: false,
    formType: "",
    initialValues: {
        name: "",
        email: "",
        mobile: "",
        password: "",
        roles: "",
        status: ""
    },
    pagination: {
        pageNo: 0,
        limit: 10,
        sortBy: 1,
        sortField: "createdAt",
        keywords: ""
    }
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        changeUserInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawer = showDrawer;
            if (formType)
                state.formType = formType;
            if (initialValues)
                state.initialValues = initialValues;
        },
        handlePaginationState: (state, action) => {
            const { payload } = action;
            state.pagination = payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { changeUserInitialState, handlePaginationState } = userSlice.actions;

export default userSlice;
